import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { isProductionRuntime } from '@/lib/app-env';
import { ROUTES } from '@/lib/route-paths';

/**
 * Layout gate for every `/wireframe-fullscreen/*` page — the same production
 * gate as `/dashboard/wireframes` (see that route file for the reasoning).
 */
export const Route = createFileRoute('/_authed/wireframe-fullscreen')({
  beforeLoad: () => {
    if (isProductionRuntime()) {
      throw redirect({ to: ROUTES.dashboard });
    }
  },
  component: WireframeFullscreenLayout,
});

function WireframeFullscreenLayout() {
  return <Outlet />;
}
